module.exports = __webpack_public_path__ + "img/single-user.6b365f16.svg";